<template>
  <div
    id="collection-methods"
    class="pt-12"
  >
    <div class="mb-6 border-b border-gray-300 pb-[1.07rem] !text-ash-200">
      <div class="flex items-center space-x-2">
        <Heading
          :level="4" color="text-ash-200"
          icon="vial"
          iconClass="text-ash-200 w-5 !h-5 mr-1.2rem"
        >
          Collection Method
        </Heading>
      </div>
    </div>

    <div class="tags flex flex-wrap items-center justify-start">
      <span
        v-for="(method, index) in collectionMethods ?? []"
        :key="index"
        class="bg-white text-ash-200 px-[0.643rem] mr-2 mb-2 border border-ash-300 rounded-[0.2142857143rem] flex justify-center items-center h-[1.714rem] text-[0.857rem]"
      >
        {{ method }}
      </span>
    </div>
  </div>
</template>

<script setup lang="ts">
import Heading from '../../../atom/heading.vue'
import type { Product } from '~~/shared/types/common'

defineProps<{
  collectionMethods?: Product['collectionMethods']
}>()

</script>
